// filter-sync.js
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    const target = e.target.closest('.facets__item label, .bundle-filter-button, .category-chip, .clear-all, .remove-chip');
    if (target) {
      handleClick(e);
    }
  });

  document.addEventListener('change', function (e) {
    const target = e.target;
    if (target.matches('.facets__form input[type="checkbox"]') || target.matches('.facets__form input[type="radio"]')) {
      handleChange(e);
    }
  });

  function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();

    const target = e.target.closest('.facets__item label, .bundle-filter-button, .category-chip, .clear-all, .remove-chip');
    let url, searchParams;

    if (target.classList.contains('bundle-filter-button') || target.tagName === 'LABEL') {
      const checkbox = target.querySelector('input[type="checkbox"]');
      const radio = target.querySelector('input[type="radio"]');
      const input = checkbox || radio;

      if (input) {
        if (input.type === 'checkbox') {
          input.checked = !input.checked;
          if (target.classList.contains('bundle-filter-button')) {
            target.classList.toggle('active', input.checked);
            target.style.display = 'none';
            target.offsetHeight;
            target.style.display = '';
          }
        } else if (input.type === 'radio') {
          document.querySelectorAll(`input[name="${input.name}"]`).forEach(r => r.checked = false);
          input.checked = true;
        }

        const form = input.closest('form');
        if (form) {
          const formData = new FormData(form);
          searchParams = new URLSearchParams(formData);
          const otherForms = document.querySelectorAll('facet-filters-form form:not(#' + form.id + ')');
          otherForms.forEach((otherForm) => {
            const otherFormData = new FormData(otherForm);
            otherFormData.forEach((value, key) => {
              if (key !== input.name || input.type !== 'radio') {
                searchParams.append(key, value);
              }
            });
          });

          if (input.type === 'checkbox' && !input.checked) {
            const filterName = input.name;
            const filterValue = input.value;
            const currentValues = searchParams.getAll(filterName);
            if (currentValues.includes(filterValue)) {
              searchParams.delete(filterName);
              currentValues.forEach(val => {
                if (val !== filterValue) {
                  searchParams.append(filterName, val);
                }
              });
            }
          }

          console.log('handleClick sort_by:', searchParams.get('sort_by')); // Debug
        }
      }
    } else if (target.classList.contains('category-chip') || target.classList.contains('clear-all') || target.classList.contains('remove-chip')) {
      url = target.closest('a')?.href || target.href;
      if (url) {
        searchParams = new URL(url).searchParams;
        console.log('handleClick URL sort_by:', searchParams.get('sort_by')); // Debug
      }
    }

    if (searchParams) {
      console.log('handleClick searchParams:', searchParams.toString()); // Debug
      FacetFiltersForm.renderPage(searchParams.toString(), e, true).then(() => {
        // Dispatch custom event after filter update
        document.dispatchEvent(new CustomEvent('facet:update'));
      });
    }
  }

  function handleChange(e) {
    e.preventDefault();
    e.stopPropagation();

    const input = e.target;
    if (input.matches('.facets__form input[type="checkbox"]') || input.matches('.facets__form input[type="radio"]')) {
      const form = input.closest('form');
      if (form) {
        const formData = new FormData(form);
        let searchParams = new URLSearchParams(formData);
        const otherForms = document.querySelectorAll('facet-filters-form form:not(#' + form.id + ')');
        otherForms.forEach((otherForm) => {
          const otherFormData = new FormData(otherForm);
          otherFormData.forEach((value, key) => {
            if (key !== input.name || input.type !== 'radio') {
              searchParams.append(key, value);
            }
          });
        });

        if (input.type === 'checkbox' && !input.checked) {
          const filterName = input.name;
          const filterValue = input.value;
          const currentValues = searchParams.getAll(filterName);
          if (currentValues.includes(filterValue)) {
            searchParams.delete(filterName);
            currentValues.forEach(val => {
              if (val !== filterValue) {
                searchParams.append(filterName, val);
              }
            });
          }
        }

        console.log('handleChange sort_by:', searchParams.get('sort_by')); // Debug
        console.log('handleChange form ID:', form.id); // Debug
        FacetFiltersForm.renderPage(searchParams.toString(), e, true).then(() => {
          // Dispatch custom event after filter update
          document.dispatchEvent(new CustomEvent('facet:update'));
        });
      } else {
        console.error('No form found for input:', input); // Debug
      }
    }
  }

  // Synchronize sort_by radio buttons across forms
  document.addEventListener('change', function (e) {
    const target = e.target;
    if (target.matches('.facets__form input[type="radio"][name="sort_by"]')) {
      const value = target.value;
      document.querySelectorAll('.facets__form input[type="radio"][name="sort_by"]').forEach(radio => {
        radio.checked = radio.value === value;
      });
      console.log('Synchronized sort_by:', value); // Debug
    }
  });
});
